import { makeConstantFactory } from 'utils/constantsHelper'
const makeConstant = makeConstantFactory('account')

export const ATTRIB_TYPES = {
  TEAMMEMBER: 'TEAMMEMBER',
  STRING: 'STRING',
  EMAIL: 'EMAIL',
  NUMBER: 'NUMBER',
  ENUM: 'ENUM',
  DATE: 'DATE',
  DATETIME: 'DATETIME',
  LATLON: 'LATLON',
  LAT: 'LAT',
  LON: 'LON',
  PHONE: 'PHONE',
  URL: 'URL',
  ENUMARRAY: 'ENUMARRAY',
}

export const FETCH_TEAMMEMBER_ATTRIBS = makeConstant('FETCH_TEAMMEMBER_ATTRIBS')
export const FETCH_TEAMMEMBER_ATTRIBS_PENDING = makeConstant('FETCH_TEAMMEMBER_ATTRIBS_PENDING')
export const FETCH_TEAMMEMBER_ATTRIBS_SUCCESS = makeConstant('FETCH_TEAMMEMBER_ATTRIBS_SUCCESS')
export const FETCH_TEAMMEMBER_ATTRIBS_FAILED = makeConstant('FETCH_TEAMMEMBER_ATTRIBS_FAILED')
export const FETCH_TEAMMEMBER_ATTRIBS_CANCELLED = makeConstant('FETCH_TEAMMEMBER_ATTRIBS_CANCELLED')

export const FETCH_ACCOUNT_ATTRIBS = makeConstant('FETCH_ACCOUNT_ATTRIBS')
export const FETCH_ACCOUNT_ATTRIBS_PENDING = makeConstant('FETCH_ACCOUNT_ATTRIBS_PENDING')
export const FETCH_ACCOUNT_ATTRIBS_SUCCESS = makeConstant('FETCH_ACCOUNT_ATTRIBS_SUCCESS')
export const FETCH_ACCOUNT_ATTRIBS_FAILED = makeConstant('FETCH_ACCOUNT_ATTRIBS_FAILED')
export const FETCH_ACCOUNT_ATTRIBS_CANCELLED = makeConstant('FETCH_ACCOUNT_ATTRIBS_CANCELLED')

export const FETCH_ACCOUNT_SEGMENTS = makeConstant('FETCH_ACCOUNT_SEGMENTS')
export const FETCH_ACCOUNT_SEGMENTS_PENDING = makeConstant('FETCH_ACCOUNT_SEGMENTS_PENDING')
export const FETCH_ACCOUNT_SEGMENTS_FAILED = makeConstant('FETCH_ACCOUNT_SEGMENTS_FAILED')
export const FETCH_ACCOUNT_SEGMENTS_SUCCESS = makeConstant('FETCH_ACCOUNT_SEGMENTS_SUCCESS')
export const FETCH_ACCOUNT_SEGMENTS_CANCELLED = makeConstant('FETCH_ACCOUNT_SEGMENTS_CANCELLED')



// WEBPACK FOOTER //
// ./src/scripts/app/modules/account/constants.js